import { z } from 'zod'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth-store'
import { PERMISSIONS } from '@/lib/rbac/permissions'
import { Memes } from '@/features/memes'

const searchSchema = z.object({
  page: z.number().int().positive().optional().catch(1),
  pageSize: z.number().int().positive().optional().catch(10),
  title: z.string().optional().catch(undefined),
  category: z
    .union([z.string(), z.array(z.string())])
    .optional()
    .catch(undefined),
  status: z
    .union([z.string(), z.array(z.string())])
    .optional()
    .catch(undefined),
  quality: z
    .union([z.string(), z.array(z.string())])
    .optional()
    .catch(undefined),
  publishState: z.string().optional().catch(undefined),
  sortBy: z.string().optional().catch(undefined),
  sortOrder: z.enum(['asc', 'desc']).optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/memes/')({
  validateSearch: (search) => searchSchema.parse(search),
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()
    if (!auth.canAccess([PERMISSIONS.MEMES.READ])) {
      throw redirect({
        to: '/403',
      })
    }
  },
  component: Memes,
})
